// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./translations/en.json";
import translationMR from "./translations/mr.json";
import translationHI from "./translations/hi.json";
import transitionsThai from "./translations/thai.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      mr: {
        translation: translationMR,
      },
      hi: {
        translation: translationHI,
      },
      thai: {
        translation: transitionsThai,
      },
    },
    debug: false,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
